import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';

export const Title = ({ children }) => (
	<Col sm={24}>
		<h2>{I18n.get(children)}</h2>
	</Col>
);
